var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as _ from "lodash";
import { components } from "react-select";
import { ImgThemeConsumer } from "../theme/ThemeHelpers";
import ImgSelect from "./ImgSelect";
import Flag from "./Flag";
import { appendPx, scaleSize } from "../theme/DefaultTheme";
var LanguageOption = function (size, margin, padding) { return function (props) {
    var data = props.data;
    var val = props.getValue()[0];
    return (React.createElement(components.Option, __assign({}, props),
        _.map(data.flags, function (f) { return React.createElement("span", { style: { marginLeft: 4 }, key: f },
            React.createElement(Flag, { marginTop: margin, paddingTop: padding, size: size, name: f })); }),
        React.createElement("span", { style: { marginLeft: 10, fontWeight: val && val.value === data.value ? 900 : undefined } }, data.label)));
}; };
var LanguageValue = function (size, margin, padding) { return function (props) {
    var data = props.data;
    return (React.createElement(components.SingleValue, __assign({}, props),
        _.map(data.flags, function (f) { return React.createElement(Flag, { marginTop: margin, paddingTop: padding, size: size, name: f, key: f }); }),
        React.createElement("span", { style: { marginLeft: 10 } }, data.label)));
}; };
var LanguageMultiValue = function (size, margin, padding) { return function (props) {
    var data = props.data;
    return (React.createElement(components.MultiValue, __assign({}, props),
        _.map(data.flags, function (f) { return React.createElement(Flag, { marginTop: margin, paddingTop: padding, size: size, name: f, key: f }); }),
        React.createElement("span", { style: { marginLeft: 10 } }, data.label)));
}; };
var LanguageSelect = function (props) {
    var onChange = props.onChange, value = props.value, languageList = props.languageList, translationFunction = props.translationFunction, isClearable = props.isClearable, isMulti = props.isMulti, rest = __rest(props, ["onChange", "value", "languageList", "translationFunction", "isClearable", "isMulti"]);
    var lngs = React.useMemo(function () { return _.orderBy(_.map(languageList, function (l) {
        var _a;
        var split = l.split("-");
        var lngPfx = split[0].toUpperCase();
        var co = (_a = split[1]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        var lng = lngPfx === "ZH" ? l : lngPfx;
        return { value: l, label: translationFunction ? translationFunction(lng) : lng, flags: co ? [co] : [] };
    }), function (o) { return o.label; }); }, [languageList, translationFunction]);
    var innerval = React.useMemo(function () {
        return _.isArray(value) ? _.filter(lngs, function (l) { return _.findIndex(value, function (v) { return v === l.value; }) >= 0; }) : _.find(lngs, function (l) { return l.value === value; });
    }, [value, lngs]);
    var chg = React.useMemo(function () { return function (value) {
        var val = _.isArray(value) ? _.map(value, function (v) { return v.value; }) : value === null || value === void 0 ? void 0 : value.value;
        if (onChange) {
            onChange(val);
        }
    }; }, [onChange]);
    return (React.createElement(ImgThemeConsumer, null, function (theme) { return (React.createElement(ImgSelect, __assign({ value: innerval !== null && innerval !== void 0 ? innerval : null, options: lngs, components: {
            Option: LanguageOption(theme.iconSize, "calc(".concat(appendPx(scaleSize(theme.iconSize, 0.5)), " - 16px)"), "calc(16px - ".concat(appendPx(scaleSize(theme.iconSize, 0.5)), ")")),
            SingleValue: LanguageValue(theme.iconSize, "calc(".concat(appendPx(scaleSize(theme.iconSize, 0.5)), " - 16px)"), "calc(16px - ".concat(appendPx(scaleSize(theme.iconSize, 0.5)), ")")),
            MultiValue: LanguageMultiValue(theme.iconSize, "calc(".concat(appendPx(scaleSize(theme.iconSize, 0.5)), " - 16px)"), "calc(16px - ".concat(appendPx(scaleSize(theme.iconSize, 0.5)), ")"))
        }, onChange: chg }, rest, { isSearchable: false, isMulti: isMulti, isClearable: isClearable }))); }));
};
export default LanguageSelect;
//# sourceMappingURL=LanguageSelect.js.map